export default () => `
  {
    shoeFinder {
      questions {
        id
        title
        description
        answers {
          id
          title
          description
        }
      }
      items {
        id
        name
        thumbUrl
        new
        offset
        category
        summary
        profile
        goal
        mainVariantId
        specs
        variants {
          id
          name
          quickViewUrl
          imageUrl
          sirvLink
          colorCodePrimary
          colorCodeSecondary
          backgroundColor
          gender
          weight
        }
      }
    }
  }
`
